var map = {
	"./drdoctor/img/icons/new_chat_main_icon.png": 605,
	"./freedoctor/img/icons/new_chat_main_icon.png": 606,
	"./freelegal/img/icons/new_chat_main_icon.png": 607,
	"./legalchief/img/icons/new_chat_main_icon.png": 608,
	"./medi4u/img/icons/new_chat_main_icon.png": 609
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 604;